import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "show-grid"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src", "onLoad"];
const _hoisted_4 = {
  class: "product-name image-info"
};
const _hoisted_5 = ["textContent"];
const _hoisted_6 = {
  key: 0,
  class: "loading"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_pixelArtDialog = _resolveComponent("pixelArtDialog");
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["masonry-container", {
      'loadendblank': $data.loadendflag
    }]),
    ref: "masonryContainer",
    "infinite-scroll-disabled": "loading",
    "infinite-scroll-distance": "10"
  }, [_createElementVNode("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "show-grid-sizer"
  }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.images, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "show-grid-item",
      key: index,
      onClick: $event => $options.onShowDialog(item)
    }, [_createElementVNode("img", {
      src: item.imagedata,
      alt: "Image",
      onLoad: $event => $options.onImageLoad($event, index)
    }, null, 40, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
      textContent: _toDisplayString($options.get_product_name(item.producttype))
    }, null, 8, _hoisted_5)])], 8, _hoisted_2);
  }), 128))]), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_6, "loading...")) : _createCommentVNode("", true)], 2)), [[_directive_infinite_scroll, $options.loadMore]]), _createVNode(_component_pixelArtDialog, {
    isdialogVisible: $data.isShowDialog,
    enableBuildDetail: true,
    piexelImgInfo: $data.selectedEffectInfo,
    particelImg: $data.selectedParticleImg,
    builddata: $data.builddata,
    onOnClose: $options.onCloseDialog,
    onOnClicklike: $options.onClicklike
  }, null, 8, ["isdialogVisible", "piexelImgInfo", "particelImg", "builddata", "onOnClose", "onOnClicklike"])], 64);
}